export default __webpack_public_path__ + "static/media/Diana-avanço-obras.19a1018d.png";